import { PopulatedAssetHolding } from "@syla/shared/types/models/AssetHoldingBase";
import { sortBy } from "lodash";

export const sortAssetHoldings = <
  THolding extends Pick<PopulatedAssetHolding, "asset">,
>(
  holdings: THolding[],
): THolding[] => sortBy(holdings, (holding) => holding.asset.code);
